//@flow
import React, {useState} from 'react';
import {makeStyles, Typography, Chip} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {Edit} from '@material-ui/icons';
import {useConversationTags} from '../../chat/utils/conversationTag';
import {colors} from '../../../../assets/styles/colors';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import InlineLoader from '../../../../elements/LoadingSpinner/InlineLoader';
import TagInput from '../../../../elements/TagInput';
import {useToggle} from '../../../../utils/react';
import ConfirmModal from '../../../../elements/Modals/ConfirmModal';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.75rem',
    borderRadius: '.75rem',
    background: 'white',
    border: `1px solid ${colors.grey300}`,
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  title: {
    fontSize: '1.125rem',
    fontWeight: 500,
  },
  createTagButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.5rem',
  },
  tagsContainer: {
    display: 'flex',
    gap: '.5rem',
    padding: '.5rem 0',
    flexWrap: 'wrap',
    marginTop: '.5rem',
  },
  tag: {
    padding: '.25rem .75rem',
    borderRadius: '1rem',
    background: colors.grey200,
    color: colors.grey700,
    fontSize: '.875rem',
    fontWeight: 500,
  },
  tagList: {
    display: 'flex',
    gap: '.5rem',
    flexWrap: 'wrap',
  },
  modalContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 480,
    maxWidth: '100%',
    position: 'relative',
    gap: '.75rem',
  },
  modalConfirmButton: {
    maxWidth: '10rem',
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelsList: {
    width: '100%',
  },
}));

export default function TagSection() {
  const classes = useStyles();

  const {
    conversationTags,
    loading,
    createTag,
    deleteTag,
  } = useConversationTags();

  const [tagIdToDelete, setTagIdToDelete] = useState<string | null>(null);
  const [open, toggleOpen] = useToggle(false);

  return (
    <section className={classes.root}>
      <header className={classes.header}>
        <Typography className={classes.title}>Etiquetas</Typography>
        <CustomButton variant="contained" onClick={toggleOpen}>
          <div className={classes.createTagButton}>
            <Edit />
            <span>Editar etiquetas</span>
          </div>
        </CustomButton>
      </header>

      <div className={classes.tagsContainer}>
        {conversationTags.map(tag => (
          <div key={tag.id}>
            <span className={classes.tag}>{tag.tag}</span>
          </div>
        ))}
      </div>

      <CustomModal open={open} handleCloseModal={toggleOpen}>
        <div className={classes.modalContainer}>
          {loading && (
            <div className={classes.loader}>
              <InlineLoader loading />
            </div>
          )}
          <Typography className={classes.title}>
            Crear etiqueta de conversación
          </Typography>

          <div className={classes.labelsList}>
            <TagInput
              tagList={conversationTags.map(({tag, id}) => ({
                id,
                label: tag,
                value: tag,
              }))}
              onAddTag={tag => {
                createTag(tag.value);
              }}
              renderTags={tagList => (
                <div className={classes.tagList}>
                  {tagList.map((item, index) => {
                    return (
                      <Chip
                        label={item.label}
                        key={item.value}
                        variant="outlined"
                        onDelete={() => {
                          if (!item.id) return;
                          setTagIdToDelete(item.id);
                        }}
                      />
                    );
                  })}
                </div>
              )}
            />
          </div>

          <CustomButton
            className={classes.modalConfirmButton}
            variant="contained"
            disabled={loading}
            onClick={toggleOpen}
            fullWidth
          >
            Cerrar
          </CustomButton>
        </div>
      </CustomModal>
      <ConfirmModal
        title="¿Estás seguro que deseas eliminar la etiqueta?"
        open={!!tagIdToDelete}
        message="Se eliminará esta etiqueta de todas las conversaciones."
        onClose={() => {
          setTagIdToDelete(null);
        }}
        onCancel={() => {
          setTagIdToDelete(null);
        }}
        onConfirm={() => {
          if (!tagIdToDelete) return;
          deleteTag(tagIdToDelete);
          setTagIdToDelete(null);
        }}
      />
    </section>
  );
}
